import { DemoVideoTypes } from 'enums/demoVideoEnums';
import { alias, serializable } from 'serializr';

export class DemoVideo {
  @serializable
  url?: string;

  @serializable
  title?: string;

  @serializable
  description?: string;

  @serializable
  type?: DemoVideoTypes;
}

export class DemoVideStatus {
  @serializable(alias('pcf_status'))
  pcfStatus?: boolean;

  @serializable(alias('ocf_status'))
  ocfStatus?: boolean;
}
